import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'

//全局注册element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//全局引入ant
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

//全局引入字体图标
import './assets/fonts/iconfont.css'
import './assets/fonts/fontStyle.css'

Vue.use(ElementUI);
Vue.use(Antd);

Vue.config.productionTip = false

import "@/util/ue4.js"
import '@/util/rem.js'


// import echarts from "echarts";

// import 'echarts-gl'
// Vue.prototype.$echarts = echarts;


import components from './components/index.js'

Object.keys(components).forEach((key) => {
  let name = key.replace(/(\w)/, (v) => v.toUpperCase())
  Vue.component(`v${name}`, components[key])
})


import plugin from './util/bus';
Vue.use(plugin);
Vue.filter('numFormat', function (value) {
  const newValue = ['', '', '']
  let fr = 1000
  let num = 3
  let text1 = ''
  let fm = 1
  while (value / fr >= 1) {
    fr *= 10
    num += 1
    // console.log('数字', value / fr, 'num:', num)
  }
  if (num <= 4) { // 千
    newValue[0] = parseInt(value / 1000) + ''
    newValue[1] = '千'
  } else if (num <= 8) { // 万
    text1 = parseInt(num - 4) / 3 > 1 ? '千万' : '万'
    // tslint:disable-next-line:no-shadowed-variable
    fm = text1 === '万' ? 10000 : 10000000
    if (value % fm === 0) {
      newValue[0] = parseInt(value / fm) + ''
    } else {
      newValue[0] = parseFloat(value / fm).toFixed(2) + ''
    }
    newValue[1] = text1
  } else if (num <= 16) { // 亿
    text1 = (num - 8) / 3 > 1 ? '千亿' : '亿'
    text1 = (num - 8) / 4 > 1 ? '万亿' : text1
    text1 = (num - 8) / 7 > 1 ? '千万亿' : text1
    // tslint:disable-next-line:no-shadowed-variable
    fm = 1
    if (text1 === '亿') {
      fm = 100000000
    } else if (text1 === '千亿') {
      fm = 100000000000
    } else if (text1 === '万亿') {
      fm = 1000000000000
    } else if (text1 === '千万亿') {
      fm = 1000000000000000
    }
    if (value % fm === 0) {
      newValue[0] = parseInt(value / fm) + ''
    } else {
      newValue[0] = parseFloat(value / fm).toFixed(2) + ''
    }
    newValue[1] = text1
  }
  if (value < 1000) {
    newValue[0] = value + ''
    newValue[1] = ''
  }
  return newValue.join('')
})
// import { $getToken } from '@/util/getToken.js'

// if (!sessionStorage.getItem("user")) {  //获取token
//   $getToken({
//     //获取token存入本地
//     username: "xiangqi",
//     password: "123456",
//   }).then((res)=>{
//     if (res) {
//       sessionStorage.setItem("user", JSON.stringify(res));
//     }  
//   })
// }
import Moment from 'moment'
// 定义全局时间戳过滤器
// Vue.filter('formatDate', function (value) {
//   return Moment(value).format('YYYY-MM-DD HH:mm:ss')
// })

Vue.prototype.$moment = Moment

import "@/assets/styles/public.scss";//全局样式
import "@/assets/styles/transition.scss"


import _ from 'lodash'
Vue.prototype._ = _

import scroll from 'vue-seamless-scroll'
Vue.use(scroll)


import publicFun from "@/util/public";
Vue.prototype.$common = publicFun
Vue.prototype.$color = "rgba(220, 34, 89, 1)"

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
